import type { FieldReadFunction } from '@apollo/client'
import { isISODateTime } from 'lib/helpers/isISODateTime/isISODateTime'
import { fromMistypedDateTime } from 'lib/helpers/mistypedDateTime/mistypedDateTime'
import { OutboundOrderSourceEnum } from 'gql/types'

/**
 * Reads an outbound order date field, narrowing manually-created orders down to their UTC calendar date.
 *
 * Integration-sourced orders keep their raw timestamp so the upstream value round-trips untouched.
 */
export const readManualOrderDate: FieldReadFunction<Maybe<string>> = (existing, { readField }) => {
  if (isISODateTime(existing) && readField('source') === OutboundOrderSourceEnum.MANUAL) {
    return fromMistypedDateTime(existing)
  }

  return existing
}
